const autoNgTemplateLoaderTemplate1 = require('./sales-dashboard.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.salesDashboard', [])
        .config(salesDashboardConfig);

    salesDashboardConfig.$inject = ['$routeProvider'];

    function salesDashboardConfig($routeProvider) {
        $routeProvider
            .when('/sales-dashboard', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'SalesDashboardController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Sales Dashboard', icon: NAVIGATION_ICON.TRENDING_UP }
                    ]
                }
            })
    }
})();
